{
    "ENV": {
        "TITLE": "DAF | Staging",
        "API": "https://staging.api.daf.werkbaarbeter.net",
        "WEBSOCKET": "",
        "QR_LOGIN": "",
        "QR_LOGIN_REFRESH_RATE": "",
        "QR_LOGIN_CHECK_RATE": "",
        "MSAL_CLIENT_ID": "6b203ccd-b384-464b-afa4-37fa930cf0e3",
        "MSAL_TENANT_ID": "e201abf9-c5a3-43f8-8e29-135d4fe67e6b",
        "MSAL_AUTHORITY": "",
        "MSAL_KNOWN_AUTHORITIES": "",
        "HAS_VIDEO": "",
        "MAP_KEY": "",
        "MAP_ID": "",
        "DEBUG": "",
        "EMAIL_LOGIN": ""
    }
}